import { render } from "./Or_tableJyutu.vue?vue&type=template&id=5e7a0b92&scoped=true&ts=true"
import script from "./Or_tableJyutu.vue?vue&type=script&lang=ts"
export * from "./Or_tableJyutu.vue?vue&type=script&lang=ts"

import "./Or_tableJyutu.vue?vue&type=style&index=0&id=5e7a0b92&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7a0b92"]])

export default __exports__